import axios from 'axios'
import { API } from './url'

function errMsg(e, fallback) {
  return (e.response && e.response.data && e.response.data.message) || fallback
}

// Read-only: the Tipsoi server instances are configured in application.properties
// (issue.tracker.systems[n].*) and surfaced here for the Systems page + Create dropdown.
export default {
  getServers: function(success, error) {
    axios.get(API.issueConfig.servers)
      .then(function(r) { success(r.data || []) })
      .catch(function(e) { error(errMsg(e, 'Failed to load systems')) })
  },

  getEnabledServers: function(success, error) {
    axios.get(API.issueConfig.servers, { params: { enabledOnly: true } })
      .then(function(r) { success(r.data || []) })
      .catch(function(e) { error(errMsg(e, 'Failed to load systems')) })
  }
}
